import { render, staticRenderFns } from "./Aplicativo.vue?vue&type=template&id=030d25b0"
import script from "./Aplicativo.vue?vue&type=script&lang=js"
export * from "./Aplicativo.vue?vue&type=script&lang=js"
import style0 from "./Aplicativo.vue?vue&type=style&index=0&id=030d25b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports